import { WishlistServiceReadyEvent, WishlistSyncedEvent } from '@studyportals/student-interfaces';
import store from '@/store';
import {
	FavouriteRemoved,
	FavouriteAdded,
	FavouriteApplicationStatusChanged,
} from '@studyportals/wishlist-service-core';
import globals from '@/utils/globals';
import { ISubscriber } from '@studyportals/event-aggregation-service-interface';
import { Dependency, Inject, ResolveDependencies } from '@/utils/dependency-decorator';

export class WishlistSyncPlugin
implements ISubscriber<FavouriteRemoved | FavouriteAdded | WishlistSyncedEvent | FavouriteApplicationStatusChanged>
{
	public async notify(): Promise<void> {
		await this.updateWishlist();
	}

	public async initiate(): Promise<void> {
		globals.eventAggregationService.subscribeTo(FavouriteAdded.EventType, this);
		globals.eventAggregationService.subscribeTo(FavouriteRemoved.EventType, this);
		globals.eventAggregationService.subscribeTo(WishlistSyncedEvent.EventType, this);
		globals.eventAggregationService.subscribeTo(FavouriteApplicationStatusChanged.EventType, this);
		await this.updateWishlist();
	}

	@ResolveDependencies
	private async updateWishlist(
		@Inject(Dependency.WISHLIST_SERVICE) wishlistServiceEvent?: WishlistServiceReadyEvent,
	): Promise<void> {
		const wishlist = await wishlistServiceEvent?.wishlistService.getWishlist();

		if (wishlist === null) {
			return;
		}

		const shallowCopyFavourites = wishlist?.favourites.slice(0);

		let favouritesInAppliyngStateCounter = 0;
		let favouritesHasAppliedCounter = 0;

		for (const favourite of shallowCopyFavourites || []) {
			if (favourite.properties.applicationStatus?.isApplying === true) {
				favouritesInAppliyngStateCounter++;
			}

			if (favourite.properties.applicationStatus?.hasApplied === true) {
				favouritesHasAppliedCounter++;
			}
		}

		store.mutations.setNumberOfFavouritesInIsApplyingState(favouritesInAppliyngStateCounter);
		store.mutations.setNumberOfFavouritesHasApplied(favouritesHasAppliedCounter);
		store.mutations.setWishlistCount(shallowCopyFavourites?.length || null);
	}
}
